//@flow
function _callTrackJsFunction(funName, ...args) {
  try {
    if (global.inServer || !global.trackJs) return;
    if (!Array.isArray(funName)) {
      global.trackJs[funName].apply(global.trackJs, args);
    } else {
      const obj = global.trackJs[funName[0]];
      obj[funName[1]].apply(obj, args);
    }
  } catch (e) {
    //eslint-disable-next-line
    console.log("TrackJs error");
  }
}

export default {
  track(e:string) {
    _callTrackJsFunction('track', e);
  },

  configure(configObj:Object) {
    _callTrackJsFunction('configure', configObj);
  },

  addMetadata(key:string, value:string) {
    _callTrackJsFunction('addMedatada', key, value);
  },

  console: {
    error(e:string) {
      _callTrackJsFunction(['console', 'error'], e);
    },

    debug(msg:string) {
      _callTrackJsFunction(['console', 'debug'], msg);
    },

    log(msg:string) {
      _callTrackJsFunction(['console', 'log'], msg);
    },
  },
};
